import { plural } from '@cian/utils';
import { SERVICE_NAMES_DICT } from '../../constants/serviceNames';

export function formatServiceName(count: number, serviceId: string): string {
  const serviceName = plural(count, SERVICE_NAMES_DICT[serviceId]);

  return serviceName;
}
